import { render, staticRenderFns } from "./ManageFunctionForm.vue?vue&type=template&id=120664bd&"
import script from "./ManageFunctionForm.vue?vue&type=script&lang=js&"
export * from "./ManageFunctionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports